import { writable, derived, get } from 'svelte/store';
const browser = typeof window !== 'undefined';
import { userSettings, updateSetting } from './userSettingsStore';

// Create a writable store for language that can be set directly
const languageStore = writable('en_US');

// Create a derived store that gets language from user settings initially
export const selectedLanguage = derived([userSettings, languageStore], ([$userSettings, $languageStore]) => {
  // If user settings are loaded, use that value
  if ($userSettings.language) {
  
    return $userSettings.language;
  }
  // Otherwise use the local store value

  return $languageStore;
});

// Create stores for translations
export const tr = writable({});
export const le = writable({});

// Subscribe to user settings changes to update local language store
if (browser) {
  userSettings.subscribe((settings) => {
    if (settings.language && settings.language !== get(languageStore)) {
      languageStore.set(settings.language);
    }
  });
}

// Subscribe to language store changes to update user settings
if (browser) {
  languageStore.subscribe((value) => {
    // Only update if it's different from current user settings
    let currentSettings;
    userSettings.subscribe(s => currentSettings = s)();
    if (currentSettings.language !== value) {
      updateSetting('language', value);
    }
  });
}

// Function to set language directly (for LanguageSelector)
export function setLanguage(language) {
  languageStore.set(language);
}

// Helper function to get a translation
export function getTranslation(key, platform = 'Web') {
  let result = null;
  tr.subscribe((t) => {
    const translation = t[`${key}|${platform}`];
    if (translation) {
      result = translation;
    }
  })();
  return result;
}

// Helper function to get translated text
export function t(key, platform = 'Web') {
  let result = key;
  let found = false;
  
  tr.subscribe((t) => {
    // First try to find by key|platform
    const translation = t[`${key}|${platform}`];
    if (translation?.content?.value) {
      result = translation.content.value;
      found = true;
    } else {
      // If not found, try to find by just the key
      const entries = Object.entries(t);
      for (const [entryKey, translation] of entries) {
        if (entryKey.startsWith(`${key}|`)) {
          result = translation.content.value;
          found = true;
          break;
        }
      }
    }
  })();

  if (!found) {
    console.warn(`Translation not found for key: ${key}, platform: ${platform}`);
  }
  
  return result;
}

// Helper function to check if a translation exists
export function hasTranslation(key, platform = 'Web') {
  let exists = false;
  tr.subscribe((t) => {
    const translation = t[`${key}|${platform}`];
    exists = !!translation?.content?.value;
  })();
  return exists;
}

export function tui(translationsVal, entriesVal, key, fallback, platform = 'Web') {
  return (
    translationsVal?.[`${key}|${platform}`]?.content?.value
    || entriesVal?.[`${key}|${platform}`]?.defaultContent?.value
    || fallback
  );
} 